module.exports = __webpack_public_path__ + "cb42221e42902f8237a377d4703de562.svg";